import { render, staticRenderFns } from "./AlumnosFilterBar.vue?vue&type=template&id=21aa8f3e&"
import script from "./AlumnosFilterBar.vue?vue&type=script&lang=js&"
export * from "./AlumnosFilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports